import { Modal, Table, message } from 'antd';
import { BellOutlined, MailOutlined, TeamOutlined } from '@ant-design/icons';
import { Team, Member } from '../types';
import type { TableProps } from 'antd';

interface TeamDetailModalProps {
  isOpen: boolean;
  team: Team | null;
  onClose: () => void;
}

export const TeamDetailModal: React.FC<TeamDetailModalProps> = ({
  isOpen,
  team,
  onClose,
}) => {
  if (!team) return null;

  const leader = team.members.find((m) => m.role === 1);

  const handleCopyEmail = (email: string, e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(email).then(
      () => {
        message.success('คัดลอกอีเมลสำเร็จ');
      },
      () => {
        message.error('ไม่สามารถคัดลอกอีเมลได้');
      }
    );
  };

  const memberColumns: TableProps<Member>['columns'] = [
    {
      title: <div style={{ fontSize: '16px' }}>Name</div>,
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: <div style={{ fontSize: '16px' }}>Email</div>,
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: <div style={{ fontSize: '16px' }}>Role</div>,
      align:"center",
      key: 'role',
      render: (_: any, member: Member) => (
        <span
          style={{
            padding: '4px 12px',
            borderRadius: '4px',
            backgroundColor: member.role === 1 ? '#fff4cc' : '#e6f4ff',
            color: member.role === 1 ? '#FFB84C' : '#0958d9',
          }}
        >
          {member.role === 1 ? 'Leader' : 'Member'}
        </span>
      ),
    },
  ];

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={800}
      centered
      title={
        <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
          {team.name}
        </div>
      }
    >
      <div style={{ marginBottom: 24, marginTop: 16 }}>
        <div
          style={{
            padding: '16px',
            backgroundColor: '#f5f5f5',
            borderRadius: '8px',
            border: "2px solid #0958d9",
            marginBottom: 16,
          }}
        >
          <p style={{ margin: 0, fontSize: '14px', display: 'flex', alignItems: 'center', gap: '6px' , color: "#0958d9" }}>
            <BellOutlined /> หากต้องการเข้าร่วมทีม กรุณาติดต่อ
          </p>
          <p
            style={{
              margin: '8px 0 0 0',
              fontSize: '16px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              cursor: 'pointer',
              transition: 'all 0.2s',
              color: "#0958d9"
            }}
            onClick={(e) => handleCopyEmail(leader?.email || '', e)}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#1890ff';
              e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#000';
              e.currentTarget.style.textDecoration = 'none';
            }}
            title="คลิกเพื่อคัดลอกอีเมล"
          >
            <MailOutlined /> {leader?.email || 'N/A'}
          </p>
        </div>

        <h4 style={{ fontSize: '18px', marginBottom: 12, display: 'flex', alignItems: 'center', gap: '6px' }}>
          <TeamOutlined /> รายชื่อสมาชิก ({team.members.length} คน)
        </h4>
        <Table
          columns={memberColumns}
          dataSource={team.members.map((m) => ({ ...m, key: m.id }))}
          pagination={false}
          size="middle"
          // bordered
        />
      </div>
    </Modal>
  );
};
